module.exports = __webpack_public_path__ + "383bcd2b1323354804f7cf1660e473c8.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-768.webp.png
// module id = 349
// module chunks = 0